import React from 'react';
import BaseIcon, { ICON_TYPE } from 'components/icon';
import classNames from 'classnames';

const FamilySearchIcon = ({ className, size } = { size: 30 }) => (
  <BaseIcon className={classNames("text-familysearch", className)} size={size} type={ICON_TYPE.FAMILY_SEARCH} />
);

export default FamilySearchIcon;
